import Navbar from '../home/components/Navbar';
import Features from '../home/components/Features';

export default function ModulesPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Features />
    </div>
  );
}
